import {createElement, PropTypes} from 'rlink-react';
import {FormattedMessage} from 'react-intl';

export default function ShopItemStatus ({css, showStatusBar, status, isDisabled, priceData, isOnSale}) {

  if (showStatusBar || isDisabled) {
    let customStatus = false;
    if (status || isOnSale === true) {
      let itemStatus = '';
      if (isDisabled === true) {
        itemStatus = <FormattedMessage
          id="ui.text.info.OUT_OF_STOCK"
          defaultMessage="Out of Stock"
          description="Displays when shop item is out of stock." />;
      } else if (status) {
        customStatus = true;
        itemStatus = status;
      } else if (isOnSale === true) {
        itemStatus = <FormattedMessage
          id="ui.label.info.SAVINGS_PERCENT_OFF"
          defaultMessage="{SAVINGS_PERCENTAGE}% off"
          description="Displays after a percentage value describing you have a certain percentage off the price."
          values={{SAVINGS_PERCENTAGE: priceData.savingsPercentage}} />;
      }

      return (<div className={`${css.status} ${(customStatus) ? css.custom : ''}`}>{itemStatus}</div>);
    }
  }
  return null;
}

ShopItemStatus.propTypes = {
  css: PropTypes.object,
  showStatusBar: PropTypes.bool,
  status: PropTypes.string,
  isDisabled: PropTypes.bool,
  priceData: PropTypes.object,
  isOnSale: PropTypes.bool,
};

ShopItemStatus.defaultProps = {
  showStatusBar: true,
};



// WEBPACK FOOTER //
// ./lib/rlink-shop/components/ShopItemStatus.jsx